import React from "react";
import { Helmet } from "react-helmet";
import { buildOrganizationSchema } from "../seo/schema";

/** Organization markup rendered once for every route (react-helmet merges script tags). */
const SiteSchema = () => (
  <Helmet>
    <script type="application/ld+json">{JSON.stringify(buildOrganizationSchema())}</script>
  </Helmet>
);

export default SiteSchema;
